import React from 'react';
import { node } from 'prop-types';

const BuyboxContainer = ({ children }) => {
  return (
    <div
      // eslint-disable-next-line max-len
      className={`sui-bg-primary sui-rounded-base sui-w-full sui-overflow-visible empty:sui-hidden ${children.key === 'buybox' ? 'sui-pl-2' : 'sui-p-2 sui-mb-2 sui-mt-2'}`}
      data-component="BundleBuybox"
      data-testid="bundle-buybox"
    >
      {children}
    </div>
  );
};

BuyboxContainer.propTypes = {
  children: node.isRequired
};

export default BuyboxContainer;
